<div
  class="container"
  [ngClass]="{ selected: isSelected }"
  (click)="onPlayerClick()"
>
  <div class="left">
    <div class="t-shirt-number">
      <span class="number">{{ playerListItem.tShirtNumber }}</span>
    </div>
  </div>
  <div class="right">
    <div #playerNameContainer class="name">
      <span
        #playerNameText
        [ngClass]="{
      'text-overflow-carousel': isActiveCarousel, 
      }"
        >{{ playerListItem.fullName }}</span
      >
    </div>
    <div class="position">
      <span>{{ playerListItem.position }}</span>
    </div>
  </div>
</div>
